import { styled, Box, Button, IconButton, CircularProgress } from '../../../../base';

export const ModalContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& .MuiAutocomplete-root': {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: '1px',
                },
            },
        },
    },
    '& .MuiButton-root:focus': {
        outline: 'none',
    },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    insetInlineEnd: theme.spacing(2),
    color: theme.palette.grey[500],
    padding: theme.spacing(1),
    zIndex: 10,
    '&:hover': {
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.grey[100],
    },
    '&:focus': {
        outline: 'none',
    },
}));

export const DayButton = styled(Button)<{ selected?: boolean }>(
    ({ theme, selected }) => ({
        flex: 1,
        minWidth: '60px',
        height: '56px',
        borderRadius: '8px',
        border: selected
            ? `2px solid ${theme.palette.warning.dark}`
            : `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        fontWeight: selected ? 600 : 400,
        padding: 0,
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
            borderColor: theme.palette.warning.main,
        },
        '&:focus': {
            outline: 'none',
        },
    })
);

export const AvailabilityScrollContainer = styled(Box)(({ theme }) => ({
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        background: theme.palette.grey[100],
        borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[400],
        borderRadius: '4px',
        '&:hover': {
            background: theme.palette.grey[500],
        },
    },
}));

export const TimeWindowContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '12px',
}));

export const AddAvailabilityButton = styled(Button)(({ theme }) => ({
    color: theme.palette.warning.main,
    textTransform: 'none',
    padding: theme.spacing(0.5, 1),
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&:focus': {
        outline: 'none',
        backgroundColor: 'transparent',
    },
}));

export const RemoveButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.grey[500],
    padding: theme.spacing(0.5),
    minWidth: '36px',
    width: '36px',
    height: '36px',
    marginTop: '24px',
    '&:hover': {
        color: theme.palette.error.main,
        backgroundColor: 'transparent',
    },
    '&:focus': {
        outline: 'none',
    },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
    minWidth: '180px',
    borderRadius: '24px',
    textTransform: 'none',
    padding: theme.spacing(1.5, 3),
    '&:focus': {
        outline: 'none',
    },
}));

export const BackButton = styled(Button)(({ theme }) => ({
    minWidth: '120px',
    borderRadius: '24px',
    textTransform: 'none',
    padding: theme.spacing(1.5, 3),
    '&:focus': {
        outline: 'none',
    },
}));

export const LoadingOverlay = styled(Box)(() => ({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 10,
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
    color: 'inherit',
}));

export const SuccessIconPlaceholder = styled(Box)(({ theme }) => ({
    width: 64,
    height: 64,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.secondary.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(2),
}));

export const AvailabilitySummaryList = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(1, 0),
}));
